import { Table as MUITable, TableContainer } from '@mui/material'
import { ReactElement } from 'react'
import Header from './Header'
import Body from './Body'

const Table = (): ReactElement => {
  return (
    <TableContainer>
      <MUITable style={{ width: 'auto' }}>
        <colgroup>
          <col style={{ width: '5%' }} />
          <col style={{ width: '10%' }} />
          <col style={{ width: '5%' }} />
          <col style={{ width: '20%' }} />
          <col style={{ width: '60%' }} />
        </colgroup>
        <Header />
        <Body />
      </MUITable>
    </TableContainer>
  )
}

export default Table
